"use client";

import React, { useState } from "react";
import { PublicAquisitionData } from "./types";
import PublicAquisitionCard from "./PublicAquisitionCard";
import { api } from "@/lib/trpc/client";
import { Button } from "@/components/ui/button";
import { translations } from "@/messages";
import { useLocale, useTranslations } from "use-intl";
import PublicAquisitionsFilters from "./PublicAquisitionsFilters";
import { PUBLIC_AQUISITIONS_TYPE } from "@ept/shared";
import { useDebounce } from "use-debounce";
import { Card } from "@/components/ui/card";
interface Props {
  initialData: PublicAquisitionData[];
  institutionSlug: string;
}
export const PublicProcurementCard: React.FC<Props> = ({
  initialData,
  institutionSlug
}) => {
  const locale = useLocale() as keyof typeof translations;
  const t = useTranslations();
  const [minDate, setMinDate] = useState<Date | undefined>();
  const [maxDate, setMaxDate] = useState<Date | undefined>();
  const [minValue, setMinValue] = useState<number | undefined>();
  const [maxValue, setMaxValue] = useState<number | undefined>();
  const [type, setType] = useState<(typeof PUBLIC_AQUISITIONS_TYPE)[number] | undefined>();
  const [procedureType, setProcedureType] = useState<string | undefined>();
  const [searchKeywords, setSearchKeywords] = useState<string | undefined>();
  const minDateDebounced = useDebounce(minDate, 500)[0];
  const maxDateDebounced = useDebounce(maxDate, 500)[0];
  const minValueDebounced = useDebounce(minValue, 500)[0];
  const maxValueDebounced = useDebounce(maxValue, 500)[0];
  const typeDebounced = useDebounce(type, 500)[0];
  const procedureTypeDebounced = useDebounce(procedureType, 500)[0];
  const searchKeywordsDebounced = useDebounce(searchKeywords, 500)[0];
  const cards = api.aquisitionsRouter.getAquisitionsForInstitution.useInfiniteQuery({
    institutionSlug,
    searchKeywords: searchKeywordsDebounced,
    type: typeDebounced,
    procedureType: procedureTypeDebounced,
    minValue: minValueDebounced,
    maxValue: maxValueDebounced,
    minDate: minDateDebounced,
    maxDate: maxDateDebounced
  }, {
    getNextPageParam: lastPage => lastPage.nextCursor
  });
  const hasFilters = minDate || maxDate || minValue || maxValue || type || procedureType || searchKeywords;
  const filteredDataLength = cards.data?.pages.reduce((acc, page) => acc + page.data.length, 0) || 0;
  return <div className="flex w-full flex-col justify-center gap-4" data-sentry-component="PublicProcurementCard" data-sentry-source-file="PublicProcurementCard.tsx">
      <PublicAquisitionsFilters minDate={minDate} setMinDate={setMinDate} maxDate={maxDate} setMaxDate={setMaxDate} minValue={minValue} setMinValue={setMinValue} maxValue={maxValue} setMaxValue={setMaxValue} type={type} setType={setType} procedureType={procedureType} setProcedureType={setProcedureType} searchKeywords={searchKeywords} setSearchKeywords={setSearchKeywords} data-sentry-element="PublicAquisitionsFilters" data-sentry-source-file="PublicProcurementCard.tsx" />
      {cards.data?.pages.map((page, i) => page.data.map(card => <PublicAquisitionCard key={card.id} card={card} />))}
      {cards.hasNextPage && <Button onClick={() => {
      cards.fetchNextPage();
    }}>
          {translations[locale]["institution"]["loadMore"]}
        </Button>}
      {!filteredDataLength && hasFilters && <Card className="rounded-3xl p-6 text-center text-base font-semibold">
          <p>
            {t("src_app_uat_institutionSlug_transparency_public_procurement_components_PublicProcurementCard_tsx_0")}
          </p>
        </Card>}
      {!initialData.length && !hasFilters && <Card className="rounded-3xl p-6 text-center text-base font-semibold">
          <p>
            {t("src_app_uat_institutionSlug_transparency_public_procurement_components_PublicProcurementCard_tsx_1")}
          </p>
        </Card>}
    </div>;
};